import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { CommonService } from '@/services/common/common.service';
import { Component, Input, OnInit } from '@angular/core';
import { Person } from '@/interfaces/person';

@Component({
  selector: 'app-search-driver-result-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.css'],
})
export class LicensesComponent implements OnInit {

  selectedUserLicenses: CompleteLicense[] = [];
  gettingLicenses: boolean = false;
  gettingLicensesError: string = '';
  zonesRows: Array<number[]> = [];

  @Input() personData!: Person;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.getLicenseBySelectedUser();
  }

  getLicenseBySelectedUser(isRefreshing: boolean | undefined = false) {
    console.log('a');
    if (this.personData.mdmid !== '') {
      if (!isRefreshing) {
        this.gettingLicenses = true;
      }
      else {
      }
      this.commonService.getLicenseByUser(this.personData.mdmid)
        .subscribe({
          next: (res) => {
            this.selectedUserLicenses = res.sort((a, b) => {
              if (a.asset.name > b.asset.name) {
                return 1;
              }
              if (a.asset.name < b.asset.name) {
                return -1;
              }
              return 0;
            });
            this.gettingLicenses = false;
            this.getZonesRows();

          },
          error: (err) => {
            this.gettingLicenses = false;
            this.gettingLicensesError = 'Hubo un problema al obtener las licencias.';
          },
        });
    }
  }

  getZonesRows() {
    this.selectedUserLicenses.forEach((license) => {
      const zonesRowsByAsset: number[] = [];
      license.equipments.forEach((vehicle) => {
        const zonesLength = vehicle.conductionZones.length;
        zonesRowsByAsset.push(Math.ceil(zonesLength / 2));
      });
      this.zonesRows.push(zonesRowsByAsset);
    });
  }


}
